if (!customElements.get('chase-home-hero')) {
  customElements.define('chase-home-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.video = this.querySelector('video');
      this.media = this.querySelector('.chase-home__media');
      this.header = document.querySelector('.section-header');
      if (!this.video || !this.media) return;
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.inView = true;
      this.playPending = false;
      this.video.defaultMuted = true;
      this.video.muted = true;
      this.video.playsInline = true;
      this.video.controls = false;
      this.video.removeAttribute('controls');
      const refresh = () => this.updateMotion();
      for (const name of ['loadedmetadata', 'canplay']) this.video.addEventListener(name, refresh, options);
      for (const name of ['touchend', 'pointerup', 'keydown']) document.addEventListener(name, refresh, { ...options, passive: true });
      document.addEventListener('visibilitychange', refresh, options);
      window.addEventListener('pageshow', refresh, options);
      this.reducedMotion.addEventListener('change', refresh, options);
      this.observer = new IntersectionObserver(([entry]) => {
        this.inView = entry.isIntersecting;
        this.updateMotion();
      });
      this.observer.observe(this.media);
      const updateHeader = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          document.documentElement.classList.toggle('chase-home-over-video', this.media.getBoundingClientRect().bottom > (this.header?.offsetHeight || 60));
        });
      };
      window.addEventListener('scroll', updateHeader, { ...options, passive: true });
      window.addEventListener('resize', updateHeader, options);
      updateHeader();
      this.updateMotion();
    }

    updateMotion() {
      if (!this.video) return;
      if (document.hidden || !this.inView || this.reducedMotion.matches) {
        this.video.pause();
        return;
      }
      if (!this.video.paused || this.playPending) return;
      this.video.muted = true;
      this.playPending = true;
      this.video.play().then(() => {
        this.removeAttribute('data-playback-blocked');
      }).catch(() => {
        this.setAttribute('data-playback-blocked', '');
      }).finally(() => {
        this.playPending = false;
        if (!this.isConnected || document.hidden || !this.inView || this.reducedMotion.matches) this.video.pause();
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.video?.pause();
      document.documentElement.classList.remove('chase-home-over-video');
    }
  });
}
